import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Typography,
  Input,
  Tabs,
  Result,
  Tooltip,
} from "antd";
import { connect } from "react-redux";

import { EMAIL_ACTION_TYPE, LOCAL_LANG } from "../common/const";
import {
  PostPasswordSet,
  GetLoginStatus,
  CreateUser,
  PostEmailRegisterSend,
} from "../config/request";
import {
  getNextPathByRegisterStatus,
  getDeviceType,
  googleStatis,
} from "../common/globalFun";
import { useIntl } from "react-intl";

import HeaderLogo from "../components/HeaderLogo";
import ErrorHintText from "../components/ErrorHintText";

import { QuestionCircleOutlined } from "@ant-design/icons";

import "./css/style.css";

const { Title } = Typography;
const { TabPane } = Tabs;

// 正则的意思是：密码中必须包含数字和字母，且长度不小于8位，且只能包含数字、字母，或者特殊字符_~@#$%^&*+=`|{}:;!.?\"()[\]-。
const regExp = /^(?=.*\d)(?=.*[a-zA-Z])[\w~@#$%^&*+=`|{}:;!.?\\"()[\]-]{8,}$/i;
// 匹配用户的密码中不允许的字符。
const unexpectedSymbolReg = /[^\w~@#$%^&*+=`|{}:;!.?\\"()[\]-]/i;

const SetPasswordPage = (props) => {
  const { history } = props;
  const intl = useIntl();

  const [form] = Form.useForm();
  const [tabsActiveKey, setTabsActiveKey] = useState("1");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");
  const [pwdStatus, setPwdStatus] = useState({
    validateStatus: "",
    errorMsg: null,
  });

  const pwdOnChange = (e, method) => {
    const pwd = e.target.value;
    method(pwd);
    if (!regExp.test(pwd)) {
      const unexpectedSymbolMatch = pwd.match(unexpectedSymbolReg);
      const unexpectedSymbol =
        unexpectedSymbolMatch && unexpectedSymbolMatch[0];

      if (unexpectedSymbol) {
        setPwdStatus({
          validateStatus: "error",
          errorMsg: (
            <ErrorHintText
              text={intl.formatMessage(
                { id: "err.pwd.unexpected.symbol" },
                { unexpectedSymbol }
              )}
            />
          ),
        });

        return;
      }

      setPwdStatus({
        validateStatus: "error",
        errorMsg: (
          <ErrorHintText
            text={intl.formatMessage({ id: "err.pwd.too.weak" })}
          />
        ),
      });
    } else {
      setPwdStatus({
        validateStatus: "",
        errorMsg: null,
      });
    }
  };

  const submit = async (values) => {
    const { password } = values;

    if (!regExp.test(password)) {
      setPwdStatus({
        validateStatus: "error",
        errorMsg: (
          <span>
            <span style={{ marginRight: 5 }}>
              {intl.formatMessage({ id: "err.pwd.too.weak" })}
            </span>
            <Tooltip title={intl.formatMessage({ id: "tip.pwd.require" })}>
              <QuestionCircleOutlined />
            </Tooltip>
          </span>
        ),
      });
      return;
    }

    setLoading(true);
    try {
      if (props.emailActionType === EMAIL_ACTION_TYPE.REGISTER) {
        await createUser();
      } else {
        await setPwd();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const createUser = () => {
    googleStatis("Signup", "Signup_setup account");
    CreateUser({
      email: props.email,
      username: username,
      password: password,
      team_name: intl.formatMessage(
        { id: "org.of.the.name" },
        { name: username }
      ),
    })
      .then((res) => {
        // 创建完成跳转验证码验证
        PostEmailRegisterSend({
          account: props.email,
          device_type: getDeviceType(),
          lang: LOCAL_LANG[intl.locale],
        })
          .then(() => {
            history.replace("/verify");
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(({ _, msg }) => {
        setPwdStatus({
          validateStatus: "error",
          errorMsg: <ErrorHintText text={msg} />,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setPwd = async () => {
    const emailActionType = props.emailActionType;
    let nextPath = "";
    let needLogin = false;
    if (emailActionType === EMAIL_ACTION_TYPE.REGISTER) {
      const { data } = props.location;
      if (data && data.nextPath) {
        nextPath = data.nextPath;
      }
      if (data && data.status) {
        nextPath = getNextPathByRegisterStatus(data.status);
        if (nextPath === "/set_pwd") {
          nextPath = "/signin_org";
          needLogin = true;
        }
      }
    }
    await PostPasswordSet({
      password: password,
      email_check_key: props.emailCheckKey,
      device_type: getDeviceType(),
      lang: LOCAL_LANG[intl.locale],
      need_login: needLogin,
    }).then(async () => {
      const emailActionType = props.emailActionType;
      if (emailActionType === EMAIL_ACTION_TYPE.FINDPWD) {
        setTabsActiveKey("2");
        return;
      }

      await GetLoginStatus().then((rsp) => {
        if (rsp.hasInvite) {
          nextPath = "/invite_list";
        }
      });
      history.replace(nextPath);
    });
  };

  return (
    <>
      <HeaderLogo />
      <Row justify={"start"} align="start" className={`main-content`}>
        <Col span={24}>
          <Title level={2} className="mt-10 page-title">
            {props.emailActionType === EMAIL_ACTION_TYPE.FINDPWD
              ? intl.formatMessage({ id: "set.new.pwd" })
              : intl.formatMessage({ id: "set.teamNameAndPwd" })}
          </Title>
          <section className="mt-30">
            <Tabs
              activeKey={tabsActiveKey}
              animated={true}
              renderTabBar={() => <></>}
            >
              <TabPane key="1">
                <Form form={form} onFinish={submit}>
                  {props.emailActionType === EMAIL_ACTION_TYPE.REGISTER && (
                    <Form.Item
                      name="username"
                      onChange={(e) => {
                        setUserName(e.target.value);
                      }}
                      rules={[{ require: true, minLength: 2 }]}
                      className="account-input"
                    >
                      <Input
                        autoFocus={
                          props.emailActionType === EMAIL_ACTION_TYPE.REGISTER
                        }
                        autocomplete="new-password"
                        placeholder={intl.formatMessage({
                          id: "set.team.name",
                        })}
                        size="large"
                        minLength={2}
                        maxLength={20}
                        disabled={loading}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    name="password"
                    onChange={(e) => {
                      pwdOnChange(e, setPassword);
                    }}
                    validateStatus={pwdStatus.validateStatus}
                    help={pwdStatus.errorMsg}
                    className="account-input"
                  >
                    <Input.Password
                      autoFocus={
                        props.emailActionType === EMAIL_ACTION_TYPE.FINDPWD
                      }
                      autocomplete="new-password"
                      placeholder={intl.formatMessage({
                        id: "set.new.pwd.please",
                      })}
                      size="large"
                      disabled={loading}
                    />
                  </Form.Item>
                  <p>{intl.formatMessage({ id: "tip.pwd.require" })}</p>
                  <Form.Item>
                    <Button
                      className={`mt-10 submit-button`}
                      block
                      size="large"
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      g-action="continue"
                      g-category="login"
                      disabled={!password || pwdStatus.validateStatus}
                    >
                      {loading ? " " : intl.formatMessage({ id: "continue" })}
                    </Button>
                  </Form.Item>
                  <div className="back-button-container">
                    <Button
                      type={"link"}
                      size={"small"}
                      onClick={() => {
                        history.push("/login");
                      }}
                      className="back-button"
                    >
                      {intl.formatMessage({ id: "btn.back" })}
                    </Button>
                  </div>
                </Form>
              </TabPane>
              <TabPane key="2">
                <Result
                  status="success"
                  title={intl.formatMessage({ id: "success.set.pwd" })}
                  subTitle={intl.formatMessage({
                    id: "reset.pwd.in.personal.center",
                  })}
                  extra={[
                    <Button
                      type="primary"
                      key="console"
                      onClick={() => {
                        history.replace("/login");
                      }}
                    >
                      {intl.formatMessage({ id: "login.now" })}
                    </Button>,
                  ]}
                />
              </TabPane>
            </Tabs>
          </section>
        </Col>
      </Row>
    </>
  );
};

const stateProps = (state) => {
  return {
    email: state.email,
    emailCheckKey: state.emailCheckKey,
    emailActionType: state.emailActionType,
    inviteCode: state.inviteCode,
  };
};

const dispatchProps = (dispatch) => ({});

export default connect(stateProps, dispatchProps)(SetPasswordPage);
